<template>
  <div class="page">
    <b-row>
      <b-col
        cols="8"
        style="padding-top:2rem; padding-left: 2rem; text-align:left;"
      >
        <!-- {{ this.ColonyDetails }} -->

        <span v-if="this.ColonyDetails[0] == 'Both'">
          <b>Testing for </b> - Legionella and Pseudomonas
        </span>
        <span v-if="this.ColonyDetails[0] != 'Both'">
          <b>Testing for </b> - {{ this.ColonyDetails[0] }}
        </span>
        <br />
        <b>Location </b> - {{ this.ColonyDetails[1] }} <br />
        <b>Flush Type</b> - {{ this.ColonyDetails[2] }} <br />
        <b>Outlet Type</b> -{{ this.ColonyDetails[3] }}
        <br />
        <b>Sample Taken</b> - {{ this.ColonyDetails[5] }} at
        {{ this.ColonyDetails[6] }} <br />
        <b>Test Commenced</b> - {{ this.ColonyDetails[10] }} at
        {{ this.ColonyDetails[11] }}
      </b-col>
      <b-col cols="4">
        <img
          src="../../assets/AGBlackGCrop.png"
          style="height:200px; margin: none; padding: none;"
        />
      </b-col>
    </b-row>
    <!-- {{ this.ColonyDetails }} -->
    <b-card>
      <template #header>
        <b> Test Result - {{ ColonyDetails[7] }} </b>
      </template>
      <b-card-body>
        <!-- {{ this.ColonyDetails }} -->
        <b-row>
          <b-col><label class="boldLabel">Test Type</label></b-col>
          <b-col><label class="boldLabel">Outlet Details</label></b-col>
        </b-row>
        <b-row>
          <b-col v-if="this.ColonyDetails[0] != 'Both'">{{
            this.ColonyDetails[0]
          }}</b-col>
          <b-col v-if="this.ColonyDetails[0] == 'Both'"
            >Legionella and Pseudomonas</b-col
          >

          <b-col>{{
            this.ColonyDetails[3] + " - " + this.ColonyDetails[4]
          }}</b-col>
        </b-row>
        <hr />

        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella cfu/1000ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella species non pneumophila cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Legionella MPN</label></b-col>
            <b-col><label class="boldLabel">Legionella Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[16] }}</b-col>
            <b-col>{{ this.ColonyDetails[17] }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><label class="boldLabel"
                >Pseudomonas aeruginosa cfu/100 ml MW4</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Total Coliforms cfu/100 ml MW10</label
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ this.ColonyDetails[18] }}</b-col>
            <b-col>{{ this.ColonyDetails[19] }}</b-col>
          </b-row>
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Escherichia coli cfu/100 ml MW10</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Pseudomonas 30 °C cfu/ml MW32</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[20] }}</b-col>
            <b-col>{{ this.ColonyDetails[21] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
            <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>

        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella cfu/1000ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col class="numberCol">{{ this.ColonyDetails[12] }}</b-col>
            <b-col class="numberCol">{{ this.ColonyDetails[13] }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella species non pneumophila cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col class="numberCol">{{ this.ColonyDetails[14] }}</b-col>
            <b-col class="numberCol">{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>

        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Legionella MPN</label></b-col>
            <b-col><label class="boldLabel">Legionella Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col class="numberCol">{{ this.ColonyDetails[16] }}</b-col>
            <b-col class="numberCol">{{ this.ColonyDetails[17] }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><label class="boldLabel"
                >Pseudomonas aeruginosa cfu/100 ml MW4</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Total Coliforms cfu/100 ml MW10</label
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col class="numberCol">{{ this.ColonyDetails[18] }}</b-col>
            <b-col class="numberCol">{{ this.ColonyDetails[19] }}</b-col>
          </b-row>
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Escherichia coli cfu/100 ml MW10</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Pseudomonas 30 °C cfu/ml MW32</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[20] }}</b-col>
            <b-col>{{ this.ColonyDetails[21] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
            <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>
        <!-- <b-spinner></b-spinner> -->
      </b-card-body>
    </b-card>
    <br v-if="this.ColonyDetails[0] == 'Both'" />
    <span class="avoid" style="font-size:11px; line-height:80%">
      Microbiological and Legionella samples that cannot be shown to have been
      tested within 24 hours and 48 hours respectively of sampling have exceeded
      accepted stability and the validity of the results may be affected.<br />Where
      the date or time of sampling is not provided, then the validity of the
      results may be affected. Comments, opinions, grades and interpretations
      herein are outside the scope of accreditation.
      <br />
      Pass/Fail criteria where shown are based on specifications as agreed with
      client general limits and do not take into account measurement of
      uncertainty, unless stated. <br />
      Unless otherwise stated, all results are expressed on a sample as received
      basis. This certificate of analysis shall not be reproduced except in
      full, without the written permission of the laboratory.
    </span>
  </div>
</template>
<script>
// import axios from "axios";
import {} from "bootstrap-vue";

export default {
  components: {},
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
  },
  data() {
    return {
      ColonyDetails: "",
      cardHeaderColor: "secondary",
      testingTabs: null,
    };
  },
  mounted() {
    this.ColonyDetails = this.$modalDetails;

    if (this.ColonyDetails[7] == "PASS") {
      this.cardHeaderColor = "success";
    } else if (this.ColonyDetails[7] == "FAIL") {
      this.cardHeaderColor = "danger";
    }
    this.testingTabs = this.$TestType;

    // if (this.ColonyDetails[0].chartAt(0) == "4") {
    // } else if (this.ColonyDetails[0].chartAt(0) == "5") {
    // }
  },
  methods: {
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {},
  },
};
</script>
<style>
.numberCol {
  border-bottom: 1px solid gray;
  /* margin-bottom: 1px;
  padding-bottom: 2px; */
}
.avoid {
  page-break-inside: avoid;
}
</style>
